import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImBin } from "react-icons/im";
import { FaSave, FaInfo } from "react-icons/fa";
import Swal from "sweetalert2";

import fundo from "../../../../styles/fundo.svg";

import './style.css'
import { useUploadAnexo } from "./UploadAnexo.js";

const Geral = styled.div`
  display: flex; 
  align-items: flex-start;
  flex-direction: row;

`;

const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;
`;

const DivContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;
  padding: 10px;
`;

const Div = styled.div`
  width: 95%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 20px 10px 10px 10px;
  align-items: start;
  gap: 20px 0px;
  flex-direction: row;
 
`;
const Div2 = styled.div`
  width: 95%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 0px;
  align-items: start;
  gap: 10px 0px;
  flex-direction: column;
  margin-top: 30px;
`;

const DivButtons = styled.div`
  max-width:100%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 5px 0px;
  align-items: start;
  flex-direction: column;
  justify-content: start;
  margin-left: 20px;
`;



const TextAreaContainer = styled.div`
  width: 100%;
  height: auto; 
  display: flex;
  flex-direction: column;
`;



const InputArea = styled.div`
  width: auto;
  height: auto; 
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 10px;


  select {
    width: 240px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0px 10px;
    background-color: #f4f4f5;
    font-size: 18px;
    color: #3a3f42;
  }



`;





const InputTitle = styled.textarea`
  min-width: 600px; 
  min-height: 200px;
  font-size: 22px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 20px;
  color: #3a3f42;
  background-color: #f4f4f5;
  overflow: auto;
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
  line-height: 1.5; /* Ajustar o espaçamento entre as linhas */
  word-wrap: break-word; /* Permitir quebra de palavras longas */
`;


const InputDescricao = styled.textarea`
  min-width: 600px; 
  min-height: 200px;
  font-size: 18px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px 10px 00px 20px;
  color: #3a3f42;
  background-color: #f4f4f5;
  resize: none; /* Desabilitar o redimensionamento manual */
  box-sizing: border-box; /* Incluir o padding e a borda na largura total */
  overflow: auto; /* Permitir a rolagem automática */
  white-space: pre-wrap; /* Manter quebras de linha e espaços */
`;



const Input = styled.input`
  width: 220px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  font-size: 18px;
  color: #3a3f42;
`;



const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  margin: 0px 5px;
  padding: 0px 0px 0px 0px; 


`;

const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;



const Tr = styled.tr`
  display: flex; 
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-top: 10px;

`;

const Tr2 = styled.tr`
  display: flex; 
  justify-content: space-between;
  text-align: center;


 
`;
export const Td = styled.td`
  font-size: 18px;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  color: #3a3f42;
  width: auto;
  text-align: start;
`;

const Table = styled.table`
  width: 800px;
  background-color: #f4f4f5;
  padding: 5px 5px;

`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`

`;

export const Th = styled.th`
  color: #3a3f42;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;
`;


const TdButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  cursor: pointer;
  border: none;
  font-weight: bold;
  color: #575757;
  background-color: #f4f4f5;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.1);
  }
`;





const ButtonNew = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #3a3f42;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  transition: transform 0.3s;
  border: 1px solid #ccc;
  border-radius: 10px;
    &:hover {

    box-shadow: 0 4px 6px gray;
  }

`;


const Form = ({ editarCartao, modalInfTarefa, urlApi, usuario, checkbox, fetchCheckbox, modalNovaTarefa, modalMover, visualizador, verQuadro, anexos, fetchAnexos, anexosTarefa }) => {


  //Token da api
  const token = localStorage.getItem('token');
  const id = parseInt(localStorage.getItem('id'));

  //-----------------------------STATE QUE COMPLETA O FORME COM OS DADOS----------------------------------------------//
  //Recebe os valores para editar, tipo onEdit
  const ref = useRef();
  useEffect(() => {

    if (editarCartao) {
      const user = ref.current;

      user.id_criador.value = editarCartao.ID_CRIADOR;
      user.id_responsavel.value = editarCartao.ID_RESPONSAVEL;
      user.titulo_card.value = editarCartao.TITULO_CARTAO;
      user.descricao_card.value = editarCartao.DESCRICAO_CARTAO;
      if (user.link_externo) user.link_externo.value = editarCartao.LINK_EXTERNO || '';
      user.data_criacao.value = editarCartao.DATA_CRIACAO;
      user.data_conclusao.value = editarCartao.DATA_CONCLUSAO;
      user.situacao.value = editarCartao.SITUACAO;
      user.recorrente.value = editarCartao.RECORRENTE;
      user.id_cocriador.value = editarCartao.ID_COCRIADOR;

    }

  }, [editarCartao]);


  //--------------------------------ALTERAR O TITULO DO CARTÂO-------------------------------------------//

  const [tituloCard, setTituloCard] = useState(editarCartao.TITULO_CARTAO);
  const [isSaveButtonVisible, setIsSaveButtonVisible] = useState(false);
  const [originalTitulo, setOriginalTitulo] = useState(editarCartao.TITULO_CARTAO); // Mantém o valor original

  const handleTituloChange = async (e) => {
    e.preventDefault();
    const newTitulo = e.target.value;
    setTituloCard(newTitulo);

    // Exibe o botão apenas se o título foi modificado
    setIsSaveButtonVisible(newTitulo !== originalTitulo);
  };

  const handleSave = async () => {
    try {
      setIsSaveButtonVisible(false);

      await axios.put(
        `${urlApi}painel-monitoramento/titulo-cartao/${editarCartao.ID_CARTAO}`,
        { titulo_cartao: tituloCard },
        { headers: { Authorization: `Bearer ${token}` } }
      );


      setOriginalTitulo(tituloCard);  // Atualiza o valor original após salvar
      // Oculta o botão após o salvamento
      toast.success("Titulo salvo com sucesso!");
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };


  //-------------------------------------ALTERA O COCRIADOR DO CARTAO/ENVIA EMAIL COCRIADOR--------------------------------------//

  const [cocriadorSelecionado, setCocriadorSelecionado] = useState(editarCartao.ID_COCRIADOR); // Mantém o ID do responsável selecionado
  const [isSaveButtonVisibleCocriador, setIsSaveButtonVisibleCocriador] = useState(false);
  const [originalCocriador, setOriginalCocriador] = useState(editarCartao.ID_COCRIADOR); // Valor original

  const handleCocriadorChange2 = (e) => {
    const novoCocriador = parseInt(e.target.value, 10); // Converte o valor do select para número
    setCocriadorSelecionado(novoCocriador);

    // Exibe o botão apenas se o ID foi modificado
    setIsSaveButtonVisibleCocriador(novoCocriador !== originalCocriador);
  };



  const handleSaveCocriador = async () => {
    try {
      setIsSaveButtonVisibleCocriador(false);

      // Atualiza no banco
      await axios.put(
        `${urlApi}painel-monitoramento/cocriador/${editarCartao.ID_CARTAO}`,
        { id_cocriador: cocriadorSelecionado },
        { headers: { Authorization: `Bearer ${token}` } }
      );


      // Busca informações do novo cocriador na lista de usuários
      const novoCocriador = usuario.find(user => user.COD_FUNCIONARIO === cocriadorSelecionado);
      const email = novoCocriador?.EMAIL;
      const nome = novoCocriador?.NOME;



      // Envia e-mail (caso não seja o próprio usuário e email válido)
      if (email && nome && cocriadorSelecionado !== id) {
        await axios.get(`${urlApi}painel-monitoramento/novo-cocriador`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            userTo: email,
            criador: nomeCriador,
            titulo: verQuadro.TITULO_QUADRO,
            nomeUsuario: nome,
            titulo_cartao: editarCartao.TITULO_CARTAO,
          }
        });
      }

      setOriginalCocriador(cocriadorSelecionado);
      toast.success("Co-criador alterado com sucesso!");
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erro ao salvar o co-criador";
      toast.error(errorMessage);
    }
  };


  //--------------------------------ALTERA O RESPONSAVEL PELO CARTÂO E ENVIA EMAIL-------------------------------------------//

  const [responsavelSelecionado, setResponsavelSelecionado] = useState(editarCartao.ID_RESPONSAVEL); // Mantém o ID do responsável selecionado
  const [isSaveButtonVisibleResponsavel, setIsSaveButtonVisibleResponsavel] = useState(false);
  const [originalResponsavel, setOriginalResponsavel] = useState(editarCartao.ID_RESPONSAVEL); // Valor original

  const handleResponsavelChange2 = (e) => {
    const novoResponsavel = parseInt(e.target.value, 10); // Converte o valor do select para número
    setResponsavelSelecionado(novoResponsavel);

    // Exibe o botão apenas se o ID foi modificado
    setIsSaveButtonVisibleResponsavel(novoResponsavel !== originalResponsavel);
  };

  const handleSaveResponsavel = async () => {
    try {
      setIsSaveButtonVisibleResponsavel(false);

      // Atualiza responsável no banco
      await axios.put(
        `${urlApi}painel-monitoramento/responsavel/${editarCartao.ID_CARTAO}`,
        { id_responsavel: responsavelSelecionado },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      // Atualiza referência original
      setOriginalResponsavel(responsavelSelecionado);

      // 🔍 Busca o usuário com base no COD_FUNCIONARIO
      const user = usuario.find(user => user.COD_FUNCIONARIO === responsavelSelecionado);
      if (!user) {
        toast.error("Usuário não encontrado.");
        return;
      }


      // Envia e-mail (caso não seja o próprio usuário e email válido)
      if (responsavelSelecionado !== id) {
        await axios.get(`${urlApi}painel-monitoramento/novo-responsavel`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            userTo: user.EMAIL,
            criador: nomeCriador,
            titulo: verQuadro.TITULO_QUADRO,
            nomeUsuario: user.NOME,
            titulo_cartao: editarCartao.TITULO_CARTAO,
          },
        });
      }



      toast.success("Responsável alterado com sucesso!");
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erro ao salvar o responsável";
      toast.error(errorMessage);
      console.error("Erro ao atualizar e enviar e-mail:", error);
    }
  };

  //-----------------------------------------------TRATA A SITUAÇÂO DO CARTÂO---------------------------------------------------//
  const opcoesSituacao = {
    AF: "A Fazer",
    PR: "Programado",
    AN: "Em Andamento",
    VA: "Em Validação",
    PA: "Pausado",
    CO: "Concluído",
    CA: "Cancelado",
    AR: "Arquivado",
  };

  const [situacao, setSituacao] = useState(editarCartao.SITUACAO);
  const [originalSituacao, setOriginalSituacao] = useState(editarCartao.SITUACAO);
  const [isSaveButtonVisibleStatus, setIsSaveButtonVisibleStatus] = useState(false);

  const handleSituacaoChange = (e) => {
    const novaSituacao = e.target.value;
    setSituacao(novaSituacao);
    setIsSaveButtonVisibleStatus(novaSituacao !== originalSituacao);
  };

  const handleSaveStatus = async () => {
    try {
      setIsSaveButtonVisibleStatus(false);

      await axios.put(
        `${urlApi}painel-monitoramento/situacao/${editarCartao.ID_CARTAO}`,
        { situacao: situacao },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setOriginalSituacao(situacao);  // Atualiza o valor original após salvar
      toast.success("Situação alterada com sucesso!");
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erro ao salvar o status";
      toast.error(errorMessage);
    }
  };

  //--------------------------------SALVA O VALOR DO CARTÃO-------------------------------------------//

  const [valorCard, setValorCard] = useState(editarCartao.VALOR_FORMATADO);
  const [isSaveButtonVisibleValor, setIsSaveButtonVisibleValor] = useState(false);
  const [originalValor, setOriginalValor] = useState(editarCartao.VALOR_FORMATADO); // Mantém o valor original


  const handleValorChange = async (e) => {
    e.preventDefault();
    const newValor = e.target.value;
    setValorCard(newValor);

    // Exibe o botão apenas se a descrição foi modificada
    setIsSaveButtonVisibleValor(newValor !== originalValor); // Correção: aqui você precisa setar o estado correto
  };

  const handleSaveValor = async () => {
    try {
      setIsSaveButtonVisibleValor(false);

      await axios.put(
        `${urlApi}painel-monitoramento/valor-cartao/${editarCartao.ID_CARTAO}`,
        { valor: valorCard }, // Corrigido: enviar a descrição correta
        { headers: { Authorization: `Bearer ${token}` } }
      );


      setOriginalValor(valorCard);  // Atualiza o valor original após salvar
      toast.success("Valor salvo com sucesso!");
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };

  //--------------------------------ALTERAR A DESCRICAO DO CARTAO-------------------------------------------//

  const [descricaoCard, setDescricaoCard] = useState(editarCartao.DESCRICAO_CARTAO);
  const [isSaveButtonVisibleDescricao, setIsSaveButtonVisibleDescricao] = useState(false);
  const [originalDescricao, setOriginalDescricao] = useState(editarCartao.DESCRICAO_CARTAO); // Mantém o valor original

  const handleDescricaoChange = async (e) => {
    e.preventDefault();
    const newDescricao = e.target.value;
    setDescricaoCard(newDescricao);

    // Exibe o botão apenas se a descrição foi modificada
    setIsSaveButtonVisibleDescricao(newDescricao !== originalDescricao); // Correção: aqui você precisa setar o estado correto
  };

  const handleSaveDescricao = async () => {
    try {
      setIsSaveButtonVisibleDescricao(false);

      await axios.put(
        `${urlApi}painel-monitoramento/descricao-cartao/${editarCartao.ID_CARTAO}`,
        { descricao_cartao: descricaoCard }, // Corrigido: enviar a descrição correta
        { headers: { Authorization: `Bearer ${token}` } }
      );


      setOriginalDescricao(descricaoCard);  // Atualiza o valor original após salvar
      toast.success("Descrição salva com sucesso!");
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };


  //--------------------------------ALTERAR O LINK EXTERNO DO CARTAO-------------------------------------------//

  const [linkExterno, setLinkExterno] = useState(editarCartao.LINK_EXTERNO || "");
  const [isSaveButtonVisibleLink, setIsSaveButtonVisibleLink] = useState(false);
  const [originalLink, setOriginalLink] = useState(editarCartao.LINK_EXTERNO || "");

  const handleLinkChange = async (e) => {
    e.preventDefault();
    const newLink = e.target.value;
    setLinkExterno(newLink);

    setIsSaveButtonVisibleLink(newLink !== originalLink);
  };

  const handleSaveLink = async () => {
    try {
      setIsSaveButtonVisibleLink(false);

      await axios.put(
        `${urlApi}painel-monitoramento/link-cartao/${editarCartao.ID_CARTAO}`,
        { link_externo: linkExterno },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setOriginalLink(linkExterno);
      toast.success("Link externo salvo com sucesso!");
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };


  //-----------------------------------INSERE A DATA DE ENTREGA DO CARTÂO----------------------------------------//

  const [dataCartao, setDataCartao] = useState(editarCartao.DATA_CONCLUSAO);
  const [isSaveButtonVisibleData, setIsSaveButtonVisibleData] = useState(false);
  const [originalData, setOriginalData] = useState(editarCartao.DATA_CONCLUSAO); // Mantém o valor original

  const handleEntregaChange = async (e) => {
    e.preventDefault();
    const newTitulo = e.target.value;
    setDataCartao(newTitulo);

    // Exibe o botão apenas se o título foi modificado
    setIsSaveButtonVisibleData(newTitulo !== originalData);
  };



  const handleSaveData = async () => {

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0); // Zera a hora para comparação exata

    const dataCartaoDate = new Date(dataCartao); // Já deve estar no formato YYYY-MM-DD
    dataCartaoDate.setHours(0, 0, 0, 0); // Zera hora também

    if (dataCartaoDate < hoje) {
      return toast.error("A data de conclusão não pode ser anterior à data de hoje.");
    }


    if (editarCartao.RECORRENTE === "S" && !dataCartao) {
      return toast.warn("Por favor a data não pode ser vazia, pois é uma tarefa recorrente");
    }

    try {
      setIsSaveButtonVisibleData(false);

      await axios.put(
        `${urlApi}painel-monitoramento/data-conclusao/${editarCartao.ID_CARTAO}`,
        { data_conclusao: dataCartao },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setOriginalData(dataCartao);  // Atualiza o valor original após salvar
      toast.success("Data salva com sucesso!");
    } catch (error) {
      if (error.response) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };


  //--------------------------------CARTAO RECORRENTE-------------------------------------------//

  const [recorrente, setRecorrente] = useState(editarCartao.RECORRENTE);
  const [isSaveButtonVisibleRecorrente, setIsSaveButtonVisibleRecorrente] = useState(false);
  const [originalRecorrente, setOriginalRecorrente] = useState(editarCartao.RECORRENTE); // Mantém o valor original

  const handleRecorrenteChange = async (e) => {
    e.preventDefault();
    const novoRecorrente = e.target.value;
    setRecorrente(novoRecorrente);

    // Exibe o botão apenas se o status foi modificado
    setIsSaveButtonVisibleRecorrente(novoRecorrente !== originalRecorrente);
  };

  const handleSaveRecorrente = async () => {

    // Verificação específica para recorrente = 'Sim'
    if (recorrente === "S" && !dataCartao) {
      return toast.warn("Por favor, selecione uma data para 'Entrega' quando o cartão for recorrente.");
    }

    try {
      setIsSaveButtonVisibleRecorrente(false);
      console.log('recorrente', recorrente)
      await axios.put(
        `${urlApi}painel-monitoramento/recorrente/${editarCartao?.ID_CARTAO}`,
        { recorrente: recorrente },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setOriginalRecorrente(recorrente);  // Atualiza o valor original após salvar
      toast.success("Recorrente salvo com sucesso!");
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erro ao salvar o recorrente";
      toast.error(errorMessage);
    }
  };

  //--------------------------------USUARIO PARA O SELECT COCRIADOR----------------------------------------------------------------------//

  const usuarioCriador = usuario.find(user => user.COD_FUNCIONARIO === editarCartao.ID_CRIADOR);
  const loginCriador = usuarioCriador ? usuarioCriador.LOGON : '';
  const nomeCriador = usuarioCriador ? usuarioCriador.NOME : '';
  const usuariosVisualizadores = visualizador
    .filter(v => v.ID_QUADRO === editarCartao.ID_QUADRO) // Filtra por quadro
    .map(v => usuario.find(user => user.COD_FUNCIONARIO === v.COD_FUNCIONARIO)) // Mapeia para usuários
    .filter(Boolean); // Remove valores undefined caso algum id_usuario não seja encontrado


  //------------------------------------------PODE EDITAR----------------------//
  const podeEditar = id === editarCartao?.ID_CRIADOR || id === editarCartao?.ID_COCRIADOR;
  const podeEditarFull1 = id === editarCartao?.ID_CRIADOR || id === editarCartao?.ID_COCRIADOR || id === editarCartao?.ID_RESPONSAVEL;
  const podeEditarFull = id === editarCartao?.ID_CRIADOR || id === editarCartao?.ID_COCRIADOR || id === checkbox?.ID_RESPONSAVEL_TAREFA || id === editarCartao?.ID_RESPONSAVEL;
  const quadroLivre = verQuadro.LIVRE === 'S';



  //------------------------------------------CHAMA MODAL TAREFAS----------------------//

  const handleTarefa = () => {
    modalNovaTarefa();
  };

  //------------------------------------------CHAMA MODAL MOVER CARTAO----------------------//

  const handleMover = () => {
    modalMover();
  };


  //-------------------------------UPLOAD ANEXO CARTAO ---------------------------------//  

  const { uploadAnexo, uploadStatus } = useUploadAnexo(urlApi, token, fetchAnexos);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    uploadAnexo(file, editarCartao.ID_CARTAO, null, id);
  };
  //-------------------------------DOWNLOAD ANEXO ---------------------------------// 
  const downloadArquivo = async (nomeSalvo) => {
    try {
      const response = await axios.get(`${urlApi}painel-monitoramento/download/${nomeSalvo}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeSalvo);
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error("Erro ao baixar arquivo:", error);
    }
  };


  //------------------------DELETA ANEXO-----------------------------------------------//

  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Essa ação é irreversível, tem certeza que gostaria de continuar?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  const handleDeleteAnexo = async (id_anexo, id_cartao = null, id_tarefa = null) => {

    const userConfirmed = await showPopUp();
    if (!userConfirmed) return;

    try {
      const params = {};

      if (id_cartao) params.id_cartao = id_cartao;
      if (id_tarefa) params.id_tarefa = id_tarefa;

      await axios.delete(`${urlApi}painel-monitoramento/deletar/${id_anexo}`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      toast.success("Anexo deletado com sucesso!");
      fetchAnexos();
      return true; // sucesso
    } catch (error) {
      console.error("Erro ao deletar anexo:", error);
      toast.error("Erro ao deletar anexo.");
      return false; // erro
    }
  };




































  //---------------------------------------------------------------------------//



  //Informações da tarefa
  const handleInfTarefa = (check) => {
    modalInfTarefa(check);
  };







  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpandir = (id) => {
    setExpandedItems(prevState => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <Geral >
      <FormContainer>
        <DivContainer ref={ref} >
          <Div>
            <TextAreaContainer>
              <InputTitle
                id="titulo_card"
                type="text"
                value={tituloCard}
                onChange={handleTituloChange}

              />

              {(podeEditar || quadroLivre) && isSaveButtonVisible && (
                <ButtonNew type="button" onClick={handleSave}>
                  <FaSave color="gold" /> Salvar
                </ButtonNew>
              )}
            </TextAreaContainer>

            <DivButtons>

              {(podeEditarFull1 || quadroLivre) && (
                <Button onClick={handleTarefa} type="button">
                  Tarefas
                </Button>
              )}

              {(podeEditar || quadroLivre) && (
                <Button onClick={handleMover} type="button">
                  Mover
                </Button>
              )}

            </DivButtons>
          </Div>
          <Div>
            <InputArea>
              <Label>Criador:</Label>
              <Input
                name="id_criador"
                value={loginCriador}
                readOnly
              />
            </InputArea>

            <InputArea>
              <Label>Co-criador</Label>
              <select
                name="id_cocriador"
                value={cocriadorSelecionado}
                onChange={handleCocriadorChange2}
              >
                <option value="">Escolha</option>
                {usuariosVisualizadores.map((user, index) => (
                  <option key={`${user.COD_FUNCIONARIO}-${index}`} value={user.COD_FUNCIONARIO}>
                    {user.LOGON} - {user.NOME}
                  </option>
                ))}

              </select>
            </InputArea>
            {((id === editarCartao.ID_CRIADOR || quadroLivre) && isSaveButtonVisibleCocriador) && (
              <ButtonNew type="button" onClick={handleSaveCocriador}><FaSave color={'gold'} />Salvar</ButtonNew>
            )}


            <InputArea>
              <Label>Responsável</Label>

              {/* Select para trocar o responsável */}
              <select
                name="id_responsavel"
                value={responsavelSelecionado}
                onChange={handleResponsavelChange2}

              >
                <option value="">Escolha</option>
                {usuariosVisualizadores.map((user, index) => (
                  <option key={`${user.COD_FUNCIONARIO}-${index}`} value={user.COD_FUNCIONARIO}>
                    {user.LOGON} - {user.NOME}
                  </option>
                ))}
              </select>


            </InputArea>
            {((podeEditar || quadroLivre) && isSaveButtonVisibleResponsavel) && (
              <ButtonNew type="button" onClick={handleSaveResponsavel}><FaSave color={'gold'} />Salvar</ButtonNew>
            )}

          </Div>
          <Div>
            <InputArea>
              <Label>Situação:</Label>
              <select
                name="situacao"
                onChange={handleSituacaoChange}
                value={situacao}
              >
                <option value="" disabled>Escolha...</option>
                {Object.entries(opcoesSituacao).map(([valor, label]) => (
                  <option key={valor} value={valor}>{label}</option>
                ))}
              </select>

            </InputArea>
            <div>
              {((podeEditar || quadroLivre) && isSaveButtonVisibleStatus) && (
                <ButtonNew type="button" onClick={handleSaveStatus}><FaSave color={'gold'} />Salvar</ButtonNew>
              )}
            </div>

            <InputArea >
              <Label>Entrega:</Label>

              <Input
                name="data_conclusao"
                type="date"
                onChange={handleEntregaChange}
                value={dataCartao}
              />

            </InputArea>
            <div>
              {((podeEditar || quadroLivre) && isSaveButtonVisibleData) && (
                <ButtonNew type="button" onClick={handleSaveData}><FaSave color={'gold'} />Salvar</ButtonNew>
              )}
            </div>

            <InputArea>
              <Label>Recorrente:</Label>

              <select name="recorrente" onChange={handleRecorrenteChange} value={recorrente} >
                <option value="" disabled>Escolha....</option>
                <option value="S">Sim, vencimento mensal</option>
                <option value="N">Não</option>
              </select>

            </InputArea>
            <div>
              {((podeEditar || quadroLivre) && isSaveButtonVisibleRecorrente) && (
                <ButtonNew type="button" onClick={handleSaveRecorrente} ><FaSave color={'gold'} />Salvar</ButtonNew>
              )}
            </div>
          </Div>
          <Div>

            <InputArea>
              <Label>Link Externo:</Label>

              <Input
                placeholder="https://..."
                name="link_externo"
                type="text"
                onChange={handleLinkChange}
                value={linkExterno}
              />
              {linkExterno && (
                <a href={linkExterno.startsWith('http') ? linkExterno : `https://${linkExterno}`} target="_blank" rel="noopener noreferrer" style={{ fontSize: '14px', color: '#007bff', marginTop: '5px' }}>
                  Acessar Link
                </a>
              )}
            </InputArea>
            <div>
              {((podeEditar || quadroLivre) && isSaveButtonVisibleLink) && (
                <ButtonNew type="button" onClick={handleSaveLink}><FaSave color={'gold'} />Salvar</ButtonNew>
              )}
            </div>

            <InputArea>
              <Label>Valor:</Label>

              <Input
                placeholder="Ex. 1000.00"
                name="valor"
                type="text"
                onChange={handleValorChange}
                value={valorCard?.trim()}

              />

            </InputArea>
            <div>
              {((podeEditar || quadroLivre) && isSaveButtonVisibleValor) && (
                <ButtonNew type="button" onClick={handleSaveValor}><FaSave color={'gold'} />Salvar</ButtonNew>
              )}
            </div>

            <InputArea>
              <Label>Criado:</Label>
              <Input
                name="data_criacao"
                readOnly
                value={editarCartao.data_criacao}
              />
            </InputArea>

          </Div>




          <Div>
            <TextAreaContainer>
              <Label>Descrição:</Label>
              <InputDescricao
                value={descricaoCard}
                onChange={handleDescricaoChange}
                id="descricao_card"

              />
              {((podeEditar || quadroLivre) && isSaveButtonVisibleDescricao) && (
                <ButtonNew type="button" onClick={handleSaveDescricao}><FaSave color={'gold'} />Salvar</ButtonNew>
              )}

            </TextAreaContainer>
          </Div>




          <Div2>


            <Table>

              <>
                {Array.isArray(checkbox) && checkbox.length > 0 && (
                  <>
                    <Label>Tarefas:</Label>
                    <Tbody>
                      {checkbox.map((check, index) => {

                        return (
                          <>
                            <Tr key={check.ID_TAREFA}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                <Td width="100%" style={{ textAlign: 'left' }}>

                                  <div style={{
                                    marginBottom: 8,
                                    textDecoration: ['CO', 'CA', 'AR'].includes(check.SITUACAO) ? 'line-through' : 'none'
                                  }}>
                                    <strong style={{ marginTop: '5px', color: '#575757' }}>Tarefa: </strong>
                                    {expandedItems[check.ID_TAREFA] ? check.DESCRICAO_TAREFA : check.DESCRICAO_TAREFA?.slice(0, 50) + '...'}

                                  </div>

                                  {check.RESPOSTA_TAREFA && (
                                    <div style={{
                                      marginBottom: 8,
                                      textDecoration: ['CO', 'CA', 'AR'].includes(check.SITUACAO) ? 'line-through' : 'none'
                                    }}>
                                      <strong style={{ marginTop: '5px', color: '#575757' }}>Resposta: </strong>
                                      {expandedItems[check.ID_TAREFA] ? check.RESPOSTA_TAREFA : check.RESPOSTA_TAREFA.slice(0, 50) + '...'}

                                    </div>
                                  )}


                                  <div style={{ marginBottom: 4 }}>

                                    {check.SITUACAO_LEGIVEL && (
                                      <>Situação: <strong style={{ marginTop: '5px', color: '#575757' }}>{check.SITUACAO_LEGIVEL}</strong> </>
                                    )}
                                    {Number(check.TOTAL_ANEXOS) > 0 && (
                                      <>
                                        | N° anexos: <strong style={{ marginTop: '5px', color: '#575757' }}>{check.TOTAL_ANEXOS}</strong>
                                      </>
                                    )}

                                    {check.DATA_CRIACAO && (
                                      <>| Criado: <strong style={{ marginTop: '5px', color: '#575757' }}>{check.DATA_CRIACAO}</strong> </>
                                    )}
                                    {check.DATA_CONCLUSAO && (
                                      <>| Entrega: <strong style={{ marginTop: '5px', color: '#575757' }}>{check.DATA_CONCLUSAO}</strong></>
                                    )}
                                  </div>

                                  <div style={{ marginTop: '5px', color: '#575757' }}>
                                    Criador: {check.NOME_CRIADOR_TAREFA}
                                  </div>
                                  <div style={{ color: '#575757' }}>
                                    Responsável: {check.NOME_RESPONSAVEL_TAREFA}
                                  </div>
                                </Td>


                                <TdButton width="5%" onClick={() => handleInfTarefa(check)} style={{ textAlign: 'right' }} type='button'>
                                  <FaInfo size={18} color="Gold" placeholder="Visualizar ou responder a tarefa" /> Info
                                </TdButton>
                              </div>
                              {check.DESCRICAO_TAREFA?.length > 50 && (
                                <div style={{ textAlign: 'center' }}>
                                  <button
                                    type="button"
                                    onClick={() => toggleExpandir(check.ID_TAREFA)}
                                    style={{
                                      color: '#007bff',
                                      border: 'none',
                                      background: 'none',
                                      cursor: 'pointer',
                                      fontSize: '14px'
                                    }}
                                  >
                                    {expandedItems[check.ID_TAREFA] ? 'Ver menos' : 'Ver mais'}
                                  </button>
                                </div>
                              )}



                            </Tr>



                          </>
                        )
                      })}
                    </Tbody>

                  </>
                )}
              </>

            </Table>

          </Div2>



          <Div2>

            <Label>Arquivos anexados:</Label>

            <div style={{ marginBottom: "16px" }}>
              {anexos.length > 0 ? (
                <Table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <Tbody>
                    {anexos.map(anexo => (
                      <Tr2 key={anexo.ID_ANEXO}>
                        <Td
                          style={{
                            padding: "8px 16px",
                            textAlign: "left",
                            whiteSpace: "nowrap"
                          }}
                        >
                          <span
                            style={{
                              color: "#007bff",
                              textDecoration: "underline",
                              cursor: "pointer"
                            }}
                            onClick={() => downloadArquivo(anexo.NOME_SALVO)}
                          >
                            {anexo.NOME_ORIGINAL}
                          </span>
                        </Td>
                        <Td
                          style={{
                            padding: "8px 16px",
                            textAlign: "left",
                            whiteSpace: "nowrap",
                            color: "#333"
                          }}
                        >
                          {anexo.DATA_CRIACAO}
                        </Td>
                        {(podeEditar || quadroLivre) && (
                          <Td
                            style={{
                              padding: "8px 16px",
                              textAlign: "left"
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => handleDeleteAnexo(anexo.ID_ANEXO)}
                              style={{
                                background: "none",
                                border: "none",
                                color: "red",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px"
                              }}
                            >
                              <ImBin color="Red" />
                              Deletar
                            </button>
                          </Td>
                        )}
                      </Tr2>
                    ))}
                  </Tbody>
                </Table>

              ) : (
                <p style={{ color: "#888" }}>Nenhum arquivo anexado.</p>
              )}
            </div>

          </Div2>

          <Div2>
            {podeEditar || quadroLivre ? (
              <section style={{ marginTop: "24px" }}>
                <Label>Adicionar novo anexo:</Label>

                <div style={{ marginTop: "8px" }}>
                  <input
                    type="file"
                    onChange={handleFileChange}
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "10px",
                      width: "100%",
                      cursor: "pointer",
                    }}
                  />
                </div>

                {uploadStatus && (
                  <p style={{ marginTop: "8px", fontSize: "14px", color: uploadStatus.includes("sucesso") ? "green" : "red" }}>
                    {uploadStatus}
                  </p>
                )}
              </section>
            ) : null}
          </Div2>

        </DivContainer>


      </FormContainer>


      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </Geral >

  );
};

export default Form;


